// Plain words for the refusals of `src/utils/outgoingEmail.js`, shared by every send screen (D180).

const WENT_NOT_RECORDED = new Set([
  'QUOTATION_EMAILED_NOT_RECORDED',
  'VENDOR_PO_EMAILED_NOT_RECORDED',
  'CLIENT_PRICE_LIST_EMAILED_NOT_RECORDED',
  'DN_EMAILED_NOT_MARKED_SENT',
]);

/** The mail went and only its record failed: the send screen closes, as a second click would mail it again (D180). */
export function emailAlreadyWent(err: unknown): boolean {
  const code = (err as { code?: unknown } | null)?.code;
  return typeof code === 'string' && WENT_NOT_RECORDED.has(code);
}

/** How long a toast saying so stays up: the page behind it still offers Send. */
export const EMAIL_WENT_NOTICE_MS = 30000;

export function emailRefusalMessage(err: unknown): string | null {
  const e = err as { code?: unknown; details?: { invalid?: unknown } } | null;
  switch (e?.code) {
    case 'EMAIL_NO_RECIPIENT':
      return 'Add at least one recipient email address, then send again. Nothing was sent.';
    case 'EMAIL_INVALID_RECIPIENT': {
      const listed = e.details?.invalid;
      const invalid = (Array.isArray(listed) ? listed : []).filter((a): a is string => typeof a === 'string' && a.trim() !== '');
      return invalid.length > 0
        ? `${invalid.join(', ')} ${invalid.length === 1 ? 'is not a valid email address' : 'are not valid email addresses'}. Correct ${invalid.length === 1 ? 'it' : 'them'}, then send again. Nothing was sent.`
        : 'A recipient email address is not valid. Correct it, then send again. Nothing was sent.';
    }
    case 'EMAIL_SUBJECT_REQUIRED':
      return 'Enter a subject, then send again. Nothing was sent.';
    case 'EMAIL_BODY_REQUIRED':
      return 'The email has no text. Write it, then send again. Nothing was sent.';
    case 'EMAIL_ALREADY_SENT':
      return 'This was already sent, so it did not go again. Reload the page to see it; you can then choose to resend.';
    case 'EMAIL_DRAFT_CHANGED':
      return 'This changed after the email text was drafted, so nothing was sent. Close this and open it again to see the new text.';
    case 'CLIENT_PRICE_LIST_EMAILED_NOT_RECORDED':
      return 'The price list was emailed to the client, but it could not be marked as sent. Do not send it again; reload the page and contact support if it still shows as not sent.';
    default:
      return null;
  }
}
